module.exports = __webpack_public_path__ + "static/media/tags.f4160ec1.svg";